var map = {
	"./Step1.svg": 1061,
	"./Step2.svg": 1062,
	"./Step3.svg": 1063,
	"./calendar_1week.svg": 1546,
	"./calendar_2weeks.svg": 1547,
	"./calendar_date.svg": 1548,
	"./calendar_hour.svg": 1549,
	"./calendar_month.svg": 1550,
	"./calendar_question.svg": 1551,
	"./continue_brief.svg": 1057,
	"./copy_brief.svg": 1056,
	"./new_brief.svg": 1058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1545;